// extracted by mini-css-extract-plugin
export var divider = "_ld-0";
export var systemMessage = "_ld-1";
export var systemMessageWrapper = "_ld-2";